import React from 'react';
import { MapContainer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { createMapPinIcon } from './MapPin';
import { CoffeeMapBasemap, COFFEE_MAP_CONTAINER_CLASS } from './CoffeeMapBasemap';

interface ShopMapSnippetProps {
    lat: number;
    lng: number;
    rating: number;
    height?: number;
    onExpand?: () => void;
}

const ShopMapSnippet: React.FC<ShopMapSnippetProps> = ({ lat, lng, rating, height = 200, onExpand }) => {
    return (
        <div
            className="rounded-sm border-brutal border-ink shadow-brutal-sm overflow-hidden relative z-0"
            style={{ height: `${height}px` }}
        >
            <MapContainer
                center={[lat, lng]}
                zoom={16}
                className={COFFEE_MAP_CONTAINER_CLASS}
                style={{ height: '100%', width: '100%' }}
                scrollWheelZoom={false}
                dragging={false}
                doubleClickZoom={false}
                touchZoom={false}
                zoomControl={false}
                attributionControl={false}
            >
                <CoffeeMapBasemap />
                <Marker
                    position={[lat, lng]}
                    icon={L.icon({
                        iconUrl: createMapPinIcon(rating, true),
                        iconSize: [32, 32],
                        iconAnchor: [16, 16]
                    })}
                />
            </MapContainer>
            {onExpand && (
                <button
                    onClick={onExpand}
                    className="absolute top-3 right-3 z-[500] bg-paper border-brutal border-ink shadow-brutal-sm rounded-sm p-2 hover:translate-x-[1px] hover:translate-y-[1px] hover:shadow-sm transition-all"
                    title="Expand map"
                >
                    <svg className="w-5 h-5 text-ink" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                        />
                    </svg>
                </button>
            )}
        </div>
    );
};

export default ShopMapSnippet;
